import { render, staticRenderFns } from "./RatesDistributions.vue?vue&type=template&id=5291fe76&scoped=true"
import script from "./RatesDistributions.vue?vue&type=script&lang=js"
export * from "./RatesDistributions.vue?vue&type=script&lang=js"
import style0 from "./RatesDistributions.vue?vue&type=style&index=0&id=5291fe76&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291fe76",
  null
  
)

export default component.exports